import { apiClient } from '../client';
import { API_ENDPOINTS } from '../../utils/constants';
import { ImageItem, ImageListResponse } from '../../types/image.types';

export const imagesApi = {
  uploadImage: async (file: File): Promise<ImageItem> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post(API_ENDPOINTS.IMAGES, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  listImages: async (params?: { page?: number; page_size?: number }): Promise<ImageListResponse> => {
    const response = await apiClient.get(API_ENDPOINTS.IMAGES, { params });
    return response.data;
  },

  getImage: async (id: number): Promise<ImageItem> => {
    const response = await apiClient.get(`${API_ENDPOINTS.IMAGES}/${id}`);
    return response.data;
  },

  renameImage: async (id: number, filename: string): Promise<ImageItem> => {
    const response = await apiClient.patch(`${API_ENDPOINTS.IMAGES}/${id}`, { filename });
    return response.data;
  },

  deleteImage: async (id: number): Promise<void> => {
    await apiClient.delete(`${API_ENDPOINTS.IMAGES}/${id}`);
  },
};
